import * as _ from 'lodash';
import * as PIXI from 'pixi.js';

import GameManager from '@/assets/js/game/GameManager';
import TextureManager from '@/assets/js/game/TextureManager';

import BackgroundData from '@/assets/data/background';
import ObjectData from '@/assets/data/object';

let container, objectContainer, isStop;

export default class Background {
  static init(stage) {
    isStop = false;
    container = new PIXI.Container();
    objectContainer = new PIXI.Container();

    const texture = TextureManager.get('bg_sky');
    const sprite = new PIXI.Sprite(texture);
    const skyWidth = GameManager.gameWidth * (GameManager.mapAreaLength + 1);
    sprite.width = GameManager.calcRatio(skyWidth);
    sprite.height = GameManager.calcRatio(GameManager.gameHeight);
    sprite.x = 0;
    sprite.y = 0;
    container.addChild(sprite);

    Background._setObject();

    container.addChild(objectContainer);
    stage.addChild(container);
  }

  static reset() {
    isStop = false;
    container.x = 0;
    objectContainer.removeChildren();
    Background._setObject();
  }

  static update() {
    if (!GameManager.isStart || isStop) return;
    container.x -= GameManager.runSpeed * 0.5;
  }

  static stop() {
    isStop = true;
    const width = GameManager.gameWidth * GameManager.mapAreaLength;
    container.x = -GameManager.calcRatio(width);
  }

  static _setObject() {
    const objectList = _.filter(BackgroundData, { level: GameManager.level });
    for (let i = 0; i < objectList.length; i++) {
      const objectInfo = objectList[i];
      const objectId = objectInfo.object_id;
      const centerX = objectInfo.center_x;
      const centerY = objectInfo.center_y;
      const objectData = _.find(ObjectData, { id: objectId });

      const texture = TextureManager.get(`${objectData.id}`);
      const sprite = new PIXI.Sprite(texture);
      sprite.width = GameManager.calcRatio(objectData.width);
      sprite.height = GameManager.calcRatio(objectData.height);
      sprite.x = GameManager.calcRatio(centerX) - sprite.width * 0.5;
      sprite.y = GameManager.calcRatio(centerY) - sprite.height * 0.5;

      objectContainer.addChild(sprite);
    }
  }
}
